import { toastB } from './toast'
let el = document.body
if (el.addEventListener) {
  window.addEventListener('online', function () {
    // toastB('网络恢复了')
  }, true)
  window.addEventListener('offline', function () {
    toastB('哎呀,网络似乎断开了')
  }, true)
} else if (el.attachEvent) {
  window.attachEvent('ononline', function () {
    // toastB('网络恢复了')
  })
  window.attachEvent('onoffline', function () {
    toastB('哎呀,网络似乎断开了')
  })
} else {
  window.ononline = function () {
    // toastB('网络恢复了')
  }
  window.onoffline = function () {
    toastB('哎呀,网络似乎断开了')
  }
}



// WEBPACK FOOTER //
// ./src/utils/check-net.js